import { notification } from 'antd';
import { getInstruments } from '../../../../../../../../../../../helpers/apiCalls';
import Table from '../Table';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import useTemplateState from '../../../../../../../../../../../../Template/atoms/variables';

const InstrumentTable = ({ instrument }) => {
  const { t } = useTranslation();
  const { instance } = useMsal();
  const [notificationApi, contextHolder] = notification.useNotification();

  const { setPendingApiCalls } = useTemplateState();

  const [instrumentDetails, setInstrumentDetails] = useState(null);

  useEffect(() => {
    triggerApiCalls();
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['getInstruments']));

      const response = await getInstruments(instance, {
        _id: instrument,
        populate: ['category', 'manufacturer'].join(';'),
      });

      setInstrumentDetails(response?.items?.[0]);
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'getInstruments'));
    }
  };

  return (
    instrumentDetails && (
      <Table
        title={t('instruments')}
        content={[
          {
            title: t('name'),
            value: instrumentDetails?.name ?? '-',
            valid: true,
            index: 0,
          },
          {
            title: t('manufacturer'),
            value: instrumentDetails?.manufacturer?.name ?? '-',
            valid: true,
            index: 1,
          },
          {
            title: t('category'),
            value: instrumentDetails?.category?.name ?? '-',
            valid: true,
            index: 2,
          },
          {
            title: t('status'),
            value: instrumentDetails?.status ?? '-',
            valid: true,
            index: 3,
          },
          {
            title: t('serial_number'),
            value: instrumentDetails?.serial_number ?? '-',
            valid: true,
            index: 4,
          },
          {
            title: t('calibrationCertificate'),
            value: instrumentDetails?.model ?? '-',
            valid: true,
            index: 5,
          },
        ]}
      />
    )
  );
};

export default InstrumentTable;
